import "./App.css";
import store from "./store";
import CarFinance from "./containers/CarFinance";
import { Provider } from "react-redux";
import { ThemeProvider } from "./components/ThemeProvider";
import { FaviconManager } from "./components/FaviconManager";

function App() {
  // lock site for current customers only
  /*const botID = new URLSearchParams(window.location.search).get('id')
    useEffect(() => {
      if(!botID){
        window.location.replace("https://google.com")
      }
    },[botID])*/

  return (
    <Provider store={store}>
      <ThemeProvider>
        <FaviconManager />
        <CarFinance />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
